// extracted by mini-css-extract-plugin
var _1 = "CarouselImage-module__container--YUaUv";
var _2 = "CarouselImage-module__image--qLSdY";
var _3 = "CarouselImage-module__imageContainer--Cpoma";
var _4 = "CarouselImage-module__shouldContain--Tos5Y";
var _5 = "CarouselImage-module__shouldFit--GbKsS";
export { _1 as "container", _2 as "image", _3 as "imageContainer", _4 as "shouldContain", _5 as "shouldFit" }
